__turbopack_context__.v({
  "beforePrice": "ProductCard-module__eC21cq__beforePrice",
  "cutline": "ProductCard-module__eC21cq__cutline",
  "image": "ProductCard-module__eC21cq__image",
  "info": "ProductCard-module__eC21cq__info",
  "moreVariants": "ProductCard-module__eC21cq__moreVariants",
  "preorder": "ProductCard-module__eC21cq__preorder",
  "price": "ProductCard-module__eC21cq__price",
  "productName": "ProductCard-module__eC21cq__productName",
  "root": "ProductCard-module__eC21cq__root",
  "tag": "ProductCard-module__eC21cq__tag",
  "tags": "ProductCard-module__eC21cq__tags",
  "title": "ProductCard-module__eC21cq__title",
});
